module.exports = __webpack_public_path__ + "img/circuit-veteran-1.f141415e.png";